export default {
  methods: {
    useInstallationName(str = '', installationName) {
      return str.replace(/woot/g, installationName);
    },
  },
};
